document.addEventListener('click',event=>{
 const button=event.target.closest('[data-step]');
 if(!button)return;
 const input=button.closest('.quantity').querySelector('input');
 const max=Number(input.max)||99;
 input.value=Math.min(max,Math.max(Number(input.min)||1,(parseInt(input.value)||1)+Number(button.dataset.step)));
 input.dispatchEvent(new Event('change',{bubbles:true}));
});
document.addEventListener('change',event=>{
 const select=event.target.closest('[data-variant]');if(!select)return;
 const form=select.closest('form');const option=select.selectedOptions[0];
 const submit=form.querySelector('[type=submit]');submit.disabled=option.dataset.available!=='true';
 submit.textContent=submit.disabled?'Chwilowo niedostępne':'Dodaj do koszyka';
 const price=form.closest('.product-content').querySelector('[data-product-price]');if(price)price.textContent=option.dataset.price;
});

;
// Progressive enhancement: content stays visible when scripts or observers are unavailable.
(() => {
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!('IntersectionObserver' in window) || !Element.prototype.animate) return;
  const seen = new WeakSet();
  const running = new Map();
  const selectors = '.strip-inner, .problem-grid > *, .product-visual, .product-content, .benefits .section-head, .benefit-grid article, .brushing .section-head, .brushing-panel, .routine-top, .steps article, .ingredients > *, .story-copy, .story-image, .faq-intro, .faq > div:last-child, .final-cta > *';
  const finish = element => {
    const animation = running.get(element);
    if (animation) { animation.cancel(); running.delete(element); }
  };
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      const element = entry.target;
      observer.unobserve(element);
      if (preference.matches || element.contains(document.activeElement)) continue;
      const siblings = [...element.parentElement.children];
      const stagger = element.matches('.steps article, .benefit-grid article, .final-cta > *');
      const delay = stagger ? Math.min(siblings.indexOf(element), 3) * 140 : 0;
      const animation = element.animate([
        { opacity: 0, transform: 'translateY(20px)' },
        { opacity: 1, transform: 'translateY(0)' }
      ], { duration: 1000, delay, easing: 'cubic-bezier(.25,.75,.25,1)', fill: 'backwards' });
      running.set(element, animation);
      animation.onfinish = () => running.delete(element);
    }
  }, { threshold: 0, rootMargin: '0px 0px -24px 0px' });
  function setup(root = document) {
    root.querySelectorAll(selectors).forEach(element => {
      if (seen.has(element)) return;
      seen.add(element);
      if (!preference.matches) observer.observe(element);
    });
  }
  document.addEventListener('focusin', event => {
    for (const element of running.keys()) if (element.contains(event.target)) finish(element);
  });
  preference.addEventListener('change', () => {
    if (preference.matches) {
      observer.disconnect();
      for (const element of running.keys()) finish(element);
    }
  });
  document.addEventListener('shopify:section:load', event => setup(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll(selectors).forEach(element => { observer.unobserve(element); finish(element); });
  });
  setup();
})();
